import {createGetServerSideProps} from 'evcharging/app';
import {LedLayout} from 'containers/led/layouts';
import {ContentSection} from 'containers/led/sections/project-intro';
import {NextPage} from 'next';
import React from 'react';
import {ProjectIntroConfirmation} from 'components/led/structures';
import {I18nPage} from "i18n/types/pages.enum";

const ProjectIntro: NextPage = () => {
  return (
    <LedLayout>
      <ContentSection />
      <ProjectIntroConfirmation />
    </LedLayout>
  );
};

export const getServerSideProps = createGetServerSideProps(
  undefined,
  undefined,
  [I18nPage.LightingRetrofitCommon, I18nPage.LightingRetrofitIntro]
);

export default ProjectIntro;
